module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921035651_T.3cb31b33.jpg";